// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MegaMenuController from "./mega_menu_controller"
application.register("mega-menu", MegaMenuController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import ProductMediaController from "./product_media_controller"
application.register("product-media", ProductMediaController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import CartFormController from "./cart_form_controller"
application.register("cart-form", CartFormController)

import PopUpCartController from "./popup_cart_controller"
application.register("popup-cart", PopUpCartController)
